module.exports = __webpack_public_path__ + "04_long_gold.52f2db29.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer5/04_long_gold.png
// module id = ThJv
// module chunks = 0